var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16359 14.6671C7.26025 14.6671 6.37959 14.6571 5.50825 14.6391C4.39358 14.6171 3.62225 13.8944 3.49625 12.7531C3.28625 10.8598 2.92692 6.39709 2.92358 6.35243C2.90092 6.07709 3.10625 5.83576 3.38159 5.81376C3.65292 5.80643 3.89825 5.99709 3.92025 6.27176C3.92359 6.31709 4.28225 10.7644 4.49025 12.6431C4.56159 13.2918 4.91158 13.6264 5.52892 13.6391C7.19559 13.6744 8.89625 13.6764 10.7296 13.6431C11.3856 13.6304 11.7403 13.3024 11.8136 12.6384C12.0203 10.7758 12.3803 6.31709 12.3843 6.27176C12.4063 5.99709 12.6496 5.80509 12.9223 5.81376C13.1976 5.83643 13.4029 6.07709 13.3809 6.35243C13.3769 6.39776 13.0156 10.8718 12.8076 12.7484C12.6783 13.9131 11.9089 14.6218 10.7476 14.6431C9.85892 14.6584 9.00159 14.6671 8.16359 14.6671Z",
    fill: "#23273B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8053 4.66016H2.5C2.224 4.66016 2 4.43616 2 4.16016C2 3.88416 2.224 3.66016 2.5 3.66016H13.8053C14.0813 3.66016 14.3053 3.88416 14.3053 4.16016C14.3053 4.43616 14.0813 4.66016 13.8053 4.66016Z",
    fill: "#23273B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6264 4.65998C10.8677 4.65998 10.2091 4.11932 10.0597 3.37532L9.89774 2.56465C9.86374 2.44132 9.72307 2.33398 9.56307 2.33398H6.74107C6.58107 2.33398 6.4404 2.44132 6.39973 2.59532L6.2444 3.37532C6.09573 4.11932 5.4364 4.65998 4.67773 4.65998C4.40173 4.65998 4.17773 4.43598 4.17773 4.15998C4.17773 3.88398 4.40173 3.65998 4.67773 3.65998C4.96173 3.65998 5.2084 3.45732 5.2644 3.17865L5.4264 2.36798C5.59107 1.74665 6.12907 1.33398 6.74107 1.33398H9.56307C10.1751 1.33398 10.7131 1.74665 10.8711 2.33798L11.0404 3.17865C11.0957 3.45732 11.3424 3.65998 11.6264 3.65998C11.9024 3.65998 12.1264 3.88398 12.1264 4.15998C12.1264 4.43598 11.9024 4.65998 11.6264 4.65998Z",
    fill: "#23273B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBlack);
export default __webpack_public_path__ + "static/media/DeleteBlack.b0ed0ebcd944bcc703805e072c2f4746.svg";
export { ForwardRef as ReactComponent };